<template>
    <span class="bullet" :style="{ 'padding-left': (paddingLeft || 0) + 'px', 'padding-right': (paddingRight || 0) + 'px' }">
        <div></div>
    </span>
</template>

<script>
export default {
    props: ['padding-left', 'padding-right']
}
</script>


<style lang="less" scoped>
    .bullet {
        display: flex;
        justify-content: center;
        align-items: center;
        > div {
            border-radius: 10px;
            border: 2px solid #979797;
        }
    }
</style>
